import axios from "axios";

export const fetchAssistance = async (assistanceRequestId, bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_ASSISTANCE,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
        params: {
          id: assistanceRequestId,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchAssistances = async (bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_ASSISTANCE,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export const addAttendee = async (externalUserId, assistanceRequestId, language, bearer) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL_REST_API_ASSISTANCE}/${assistanceRequestId}/attendees`,
      {
        external_user_id: externalUserId,
        send_invitation: true,
        language,
      },
      {
        headers: {
          Authorization: `Bearer ${bearer}`
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export const fetchScenario = async (scenarioId, bearer) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL_REST_API}/operators/scenarios/${scenarioId}/datas`,
      {
        headers: {
          Authorization: `Bearer ${bearer}`
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
}
